import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

export interface ContractValidationsAlertProps {
  /** `header.validations[]` — pendências do contrato, como vieram do backend. */
  readonly validations: readonly string[] | null | undefined;
}

/**
 * Faixa de pendências do contrato financeiro.
 *
 * `header.validations[]` não é exibido na tela legada; aqui ele vira um aviso no
 * topo, porque é a única pista que o operador tem de que o contrato precisa de
 * atenção antes de qualquer operação nas parcelas.
 *
 * Nada é renderizado quando o array vem vazio, `null` ou ausente.
 */
export function ContractValidationsAlert({ validations }: ContractValidationsAlertProps) {
  const { t } = useTranslation('individualPayment');

  const messages = (validations ?? []).filter(message => Boolean(message?.trim()));
  if (messages.length === 0) return null;

  return (
    <div
      role="status"
      className="flex gap-micro rounded-sm bg-base-warning-100 p-mini"
      data-testid="contract-validations"
    >
      <ExclamationTriangleIcon className="mt-quark h-xxs w-xxs shrink-0 text-base-warning-800" />
      <div className="flex flex-col gap-quark">
        <p className="ts-subtitle-xxs text-base-warning-900">
          {t('parcels.validations.title', { count: messages.length })}
        </p>
        <p className="ts-caption-xxs text-base-warning-800">{messages.join('  ·  ')}</p>
      </div>
    </div>
  );
}
